// extracted by mini-css-extract-plugin
export default {"labelAndIcons":"match_card_shortlist_button_wrapper-module___labelAndIcons___c75449cf"};